module.exports = __webpack_public_path__ + "img/allShield.d9385d1f.png";